import React, { useState } from "react";
import {
  Navbar,
  Page,
  BlockTitle,
  Range,
  List,
  ListItem,
  Icon,
  Block,
} from "framework7-react";

import "./Annual_Income.css";
import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import RedRoundBtn from "../../../Common_Btn/RedRoundBtn/RedRoundBtn";
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
// import { Page, Navbar, Block, Range } from 'framework7-react';
// import RangeSelector, {
//     Margin,
//     Scale,
//     MinorTick,
//     Marker,
//     Label,
//     Behavior,
//     SliderMarker,
// } from 'devextreme-react/range-selector';

const Annual_Income = ({income ,setIncome,...props}) => {


  
  

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setValue,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
  } = useForm();


  const handleInputChange = (event) => {
    let newValue = parseInt(event.target.value, 10) || 0; // Ensure numeric value
    if (newValue > 2500000) newValue = 2500000; // Max limit
    if (newValue < 0) newValue = 0; // Min limit

    setIncome(newValue);
  };

  console.log(income,"income income");
  const handleSliderChange = (value) => {
    setIncome(value[1]); // Update with max value from slider
  };
  return (
    <section className="Annual_Income">
      <div className="top_holder">
        <p className="step_title">Select your annual Income</p>

        <div className="income_div blue_label_group ">
          <Form.Control
            type="text"
            name="name"
            placeholder="Enter Annual Income"
            value={income}
            onChange={handleInputChange} 
          />
        </div>

        <div className="range_slider_holder">
          <div className="main_range_slider">
            <RangeSlider
             min={0}
             max={3000000}
             value={[0, income]}
             thumbsDisabled={[true, false]}
             onInput={handleSliderChange} 
            />
          </div>
          <span className="range_text min_range">Less than 2 Lac</span>
          <span className="range_text max_range">25+ Lac</span>
        </div>
      </div>

      <div className="scale_holder">
        {/* <Range
                    min={0}
                    max={100}
                    label={true}
                /> */}

        {/* <Scale
                    startValue={startValue}
                    endValue={endValue}
                    minorTickInterval="day"
                    tickInterval="month"
                >
                    <MinorTick visible={false} />
                    <Marker visible={false} />
                    <Label format="MMM" />
                </Scale> */}
      </div>

      <div className="Continue_btn_holder">
        <RedRoundBtn
          btn_name="Continue"
          onClick={() => {
            props?.handleNext();
          }}
        />
      </div>
    </section>
  );
};

export default Annual_Income;
